/**
 * import and init third party
 * components/validators and other dependencies
 */

import Vue from 'vue'
import VueJWT from 'vuejs-jwt'

Vue.use(VueJWT, {})
